import { checklistNotifiableListCodec, intoSendable, intoEditable } from '@/services/api/resources/checklistNotifiable';
import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import {
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  decode,
  fetchApi,
  setBody,
} from '@/services/api';
import { ChecklistNotifiableEditable } from '@/ui/DTO';

const baseUrl = (checklistId: string) => `/v2/checklists/${checklistId}/notifiables`;

export const list = (checklistId: string) => pipe(
  baseUrl(checklistId),
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(checklistNotifiableListCodec)),
  map(response => response.data.map(intoEditable)),
);

export const save = (checklistId: string, checklistNotifiables: ChecklistNotifiableEditable[]) => pipe(
  baseUrl(checklistId),
  createAuthorizedPostRequest,
  map(setBody(checklistNotifiables.map(intoSendable))),
  chain(fetchApi),
);
